export default __webpack_public_path__ + "static/media/addIcon.3c16c827.svg";